import { FC, createElement } from 'react';
import { ButtonProps } from './types';

import ButtonStandard from './ButtonStandard';
import ButtonText from './ButtonText';
import ButtonIcon from './ButtonIcon';

const buttonVariants = {
  primary: ButtonStandard,
  outline: ButtonStandard,
  text: ButtonText,
  icon: ButtonIcon,
  simple: ButtonStandard,
};

const Button: FC<ButtonProps> = ({
  variant = 'primary',
  children,
  ...props
}: ButtonProps) =>
  createElement(buttonVariants[variant], { ...props, variant }, children);

export default Button;
